// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HubLogout.Button-module__Button:not([disabled]):hover{background:transparent}", "",{"version":3,"sources":["webpack://./HubLogout.scss"],"names":[],"mappings":"AAAA,uDACE,sBAAA","sourcesContent":[".HubLogout.Button-module__Button:not([disabled]):hover {\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
